const CollaborateEdit = () =>
    import("@songfinch/customer/views/collaboration/CollaborateEdit.vue");
const CollaborateReview = () =>
    import("@songfinch/customer/views/collaboration/CollaborateReview.vue");

export default [
    {
        path: "/collaborate/:slug/collaborate",
        name: "CollaborateEdit",
        component: CollaborateEdit,
        meta: {
            requireAuth: true,
            hideTopBar: true,
            hideNavigation: true,
            hideFooter: true,
            hideStartButton: true,
        },
    },
    {
        path: "/collaborate/:slug/review",
        name: "CollaborateReview",
        component: CollaborateReview,
        meta: {
            requireAuth: true,
            hideTopBar: true,
            hideNavigation: true,
            hideFooter: true,
            hideStartButton: true,
        },
    },
];
